import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { UpdateOneShopReturnToStoreStoreDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type UseUpdateShopStoreParams = {
  shopId: string;
  storeId: string;
  onSettled?: (
    data: unknown,
    error: Error | null,
  ) => Promise<unknown> | unknown;
};

/**
 * Types are not done on the API
 */
// function oldUpdate(shop: ShopDto, storeId: string, store: any) {
//   return Meteor.callAsync("updateStore", {
//     shopId: shop.id,
//     storeId,
//     store
//   });
// }

export default function useUpdateShopStore({
  shopId,
  storeId,
  onSettled,
}: UseUpdateShopStoreParams) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);
  const mutation = $api.useMutation("patch", "/shops/{shopId}/return-to-store/stores/{storeId}");

  return useMutation({
    onSettled,
    onError: () => {
      errorNotification();
    },
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    mutationFn: async (requestBody: UpdateOneShopReturnToStoreStoreDto) => {
      return mutation.mutateAsync({
        params: { path: { shopId, storeId } },
        body: requestBody,
      });
    },
  });
}
